export default {
  // Días de la semana — selector de ConfiguratorDialog/ViewSection.vue
  sunday: 'Domingo',
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miercoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sabado',

  // Selector de vista de agenda — IndexAgenda.vue
  agenda: {
    month: 'Mes',
    week: 'Semana',
    day: 'Día'
  }
}
